import { ValidationObserver } from "vee-validate/dist/vee-validate.full";
import BInput from "@/components/singles/BInput/component.vue";

export default {
  name: "EditableText",
  components: {
    ValidationObserver,
    BInput
  },
  props: [
    "name",
    "label",
    "type",
    "validation",
    "value",
    "icon",
    "placeholder",
    "savePath",
    "valueProp",
    "idProp",
    "idValue",
    "skipSaveMessage"
  ],
  data() {
    return {
      edit: false,
      originalValue: String
    };
  },
  created() {},
  mounted() {},
  methods: {
    UpdateValue(event) {
      this.$emit("input", event);
    },
    async Save(value) {
      if (value !== this.originalValue) {
        let valid = await this.$refs.observer.validate();

        if (this.edit && valid) {
          this.SaveChange(value);
        } else {
          this.$helpers.ShowStatus(`Not saved`, 1000, "warning");
          this.$emit("input", this.originalValue);
        }
      }

      this.edit = !this.edit;
    },
    async SaveChange(value) {
      this.$emit("saving", "success");

      if (this.type === "number") {
        value = parseInt(value);
      }

      this.$helpers
        .PostApi(this.savePath, {
          [this.idProp]: this.idValue,
          object: {
            [this.valueProp || this.name]: value
          }
        })
        .then(res => {
          if (res[0].changed) {
            this.SaveSuccess(res);
          } else {
            this.SaveError("Nothing was saved");
          }
        })
        .catch(err => {
          this.SaveError(`Save failed: Error code ${err.response.status}`);
        });
    },
    SaveSuccess(res) {
      if (!this.skipSaveMessage) {
        this.$helpers.ShowStatus(`Saved`, 1000);
      }

      this.$emit("saved", {
        error: false,
        result: res
      });
    },
    SaveError(message) {
      if (!this.skipSaveMessage) {
        this.$helpers.ShowStatus(message, 0, "warning");
      }

      this.$emit("input", this.originalValue);
    }
  }
};
